import {Component, Input, OnInit} from '@angular/core';
import {FilesService} from '../../../../services/files.service';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'ngx-politics',
  templateUrl: './politics.component.html',
  styleUrls: ['./politics.component.scss'],
})
export class PoliticsComponent implements OnInit {
  @Input() stationId;
  @Input() stationData: any;
  constructor(private fileService: FilesService) { }

  loading = false;

  ngOnInit() {
  }

  async downloadPolitic() {
    const url = `${environment.baseEndpoint}/nom035/politic?stationId=${this.stationId}`;
    this.loading = true;
    await this.fileService.downloadFile(url);
    this.loading = false;
  }

}
